module.exports = __webpack_public_path__ + "img/home_bg2.936e05ad.jpg";